import React, { Box, Divider, Drawer, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { AccountBox, Logout } from '@mui/icons-material';
import { useSiteNavigation } from 'hooks';
import { AppLogoIcon } from 'icons';
import { CoreRoutes } from 'app-constants';
import { useSharedState } from 'context';
import { ResponsiveDrawerProps } from './ResponsiveDrawerProps';

export const ResponsiveDrawer = ({ drawerWidth }: ResponsiveDrawerProps) => {
	const { sharedState, setSharedState } = useSharedState();
	const handleClose = () => {
		setSharedState(!sharedState);
	};
	const { navigation } = useSiteNavigation();
	const drawer = (
		<div>
			<ListItem key='App Logo'>
				<AppLogoIcon style={{ width: 'auto', height: '48px', margin: 'auto' }} />
			</ListItem>
			<Divider />
			<List>
				<ListItem key='My Business'>
					<Typography>BUSINESS EXCELLENCE</Typography>
				</ListItem>
				{navigation.map(obj => (
					<Link key={obj.name} href={obj.link}>
						<ListItem disablePadding>
							<ListItemButton>
								<ListItemIcon>{obj.icon}</ListItemIcon>
								<ListItemText primary={obj.name}></ListItemText>
							</ListItemButton>
						</ListItem>
					</Link>
				))}
			</List>
			<Divider />
			<List>
				<ListItem key='My Account'>
					<Typography>MY ACCOUNT</Typography>
				</ListItem>
				{[
					{
						name: 'Account information',
						link: CoreRoutes.accountInformation,
						icon: <AccountBox />,
					},
					{ name: 'Log out', link: CoreRoutes.logout, icon: <Logout /> },
				].map(obj => (
					<Link key={obj.name} href={obj.link}>
						<ListItem disablePadding>
							<ListItemButton>
								<ListItemIcon>{obj.icon}</ListItemIcon>
								<ListItemText primary={obj.name}></ListItemText>
							</ListItemButton>
						</ListItem>
					</Link>
				))}
			</List>
		</div>
	);

	return (
		<Box component='nav' sx={{ width: { sm: drawerWidth }, flexShrink: 0 }}>
			<Drawer
				variant='temporary'
				open={sharedState}
				onClose={handleClose}
				ModalProps={{
					keepMounted: true,
				}}
				sx={{
					display: { xs: 'block', sm: 'none' },
					'& .MuiDrawer-paper': {
						boxSizing: 'border-box',
						width: drawerWidth,
					},
				}}
			>
				{drawer}
			</Drawer>
			<Drawer
				variant='permanent'
				open
				sx={{
					display: { xs: 'none', sm: 'block' },
					'& .MuiDrawer-paper': {
						boxSizing: 'border-box',
						width: drawerWidth,
					},
				}}
			>
				{drawer}
			</Drawer>
		</Box>
	);
};
